module.exports = __webpack_public_path__ + "img/icon3.c61dbb1f.png";